import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import Table from './CostCenterTable';
import Pagination from '../../CustomControls/Pagination';
import { getAllCostCenters, setOnConfirmationModal, deleteCostCenter } from '../../../store/actions/Master/costCenter';
import LoadingSpinner from '../../CustomControls/Spinner';
import Notification from '../../CustomControls/Notification';
import Breadcrumbs from '../../CustomControls/Breadcrumb';
import { _create, _costcenter, _delete } from '../../../constants/componentConstants';
import { hasPermissionToAction } from '../../../utils/accessUtil';
import SearchBar from '../../CustomControls/SearchBar';
import CustomConfirmation from '../../CustomControls/ConfirmationModal';

import './style.scss';

const CostCenter = props => {
  const [searchText, setSearchText] = useState('');
  const [results, setResults] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const costCenter = useSelector(state => state.costCenter);
  const ui = useSelector(state => state.ui);
  const permissions = ui.layout.permissions;
  const pageSize = ui.layout.pageSize;

  const notificationType = costCenter.isError ? 'error' : 'success';

  const showSaveOption = hasPermissionToAction(permissions, _costcenter, _create);
  const showDeleteOption = hasPermissionToAction(permissions, _costcenter, _delete);

  useEffect(() => {
    dispatch(getAllCostCenters());
  }, [dispatch]);

  useEffect(() => {
    if (searchText.length > 0) {
      setResults(
        costCenter.costCenterList.filter(
          x =>
            x.costCenterCode.toLowerCase().includes(searchText.toLowerCase()) ||
            x.costCenterName.toLowerCase().includes(searchText.toLowerCase()) ||
            x.clientProfileName.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    } else {
      setResults(costCenter.costCenterList);
    }
  }, [searchText, setResults, costCenter.costCenterList]);

  const onPageChangeHandler = currentPage => {};

  const onAddNewHandler = () => {
    history.push('/master/cost-centers/cost-center');
  };

  const onEditHandler = id => {
    history.push(`/master/cost-centers/cost-center/${id}`);
  };

  const breadCrumbPaths = [
    { id: 1, title: 'Home', path: '/' },
    { id: 2, title: 'Cost Center Listing', path: '/master/cost-centers', isCurrent: true }
  ];

  const handleInput = e => {
    setSearchText(e.target.value);
  };

  const onDeleteHandler = id => {
    dispatch(
      setOnConfirmationModal({
        data: {
          showConfirmationModal: true,
          confirmationId: id
        }
      })
    );
  };

  const onDeleteConfirmation = () => {
    if (costCenter.confirmationId) {
      dispatch(deleteCostCenter(costCenter.confirmationId));
    }
  };

  const onDeleteCancel = () => {
    dispatch(
      setOnConfirmationModal({
        data: {
          showConfirmationModal: false,
          confirmationId: ''
        }
      })
    );
  };

  return (
    <React.Fragment>
      <CustomConfirmation
        show={costCenter.showConfirmationModal}
        onDeleteClick={onDeleteConfirmation}
        onCloseClick={onDeleteCancel}
        message="Are you sure you want to delete this record?"
        header="Deleting record"
      />
      <div className="page-content">
        {costCenter.showMessage && <Notification notificationType={notificationType} message={costCenter.message} />}
        <Container fluid>
          <Breadcrumbs title="Cost Center Listing " paths={breadCrumbPaths} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row className="mb-2 buttonrow">
                    <Col sm="4">
                      <SearchBar onChange={handleInput} placeholder="Search" value={searchText} />
                    </Col>
                    <Col sm="8">
                      <div className="text-sm-end">
                        {showSaveOption && (
                          <Button type="button" className="btn btn-primary btn-block  app-add-button" onClick={onAddNewHandler}>
                            ADD COST CENTER
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row className="tablerow">
                    <Col xl="12">
                      <div>
                        {costCenter.isLoading && <LoadingSpinner />}
                        <Pagination data={results} pageSize={pageSize} onPageChange={onPageChangeHandler} startingPage={1}>
                          <Table editHandler={onEditHandler} deleteHandler={onDeleteHandler} showDelete={showDeleteOption} />
                        </Pagination>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CostCenter;
